export default __webpack_public_path__ + "a6cb56e50919aa7e95cf09e5b218c386.png";